<template>
	<div class="admin-manager-sites-info">
		<SitesList max-items="3" pagination :data="sitesProfilesPairs">
			<template slot-scope="{ data }">
				<vs-tr
					v-for="(pair, pairIndex) in data"
					:key="pairIndex"
				>
					<vs-td>
						<div class="vx-row overflow-visible">
							<div
								v-for="(siteProfile, siteIndex) in pair"
								:key="siteIndex"
								:class="`w-1/${data[0].length} manager-card-container`"
								class="vx-col"
							>
								<div class="manager-card w-full">
									<div class="manager-card__photo">
										<img :src="siteProfile.photo">
									</div>
									<div class="manager-card__info">
										<div class="manager-card__name">
											{{ siteProfile.username }}
										</div>
										<div class="manager-card__site">
											{{ $getDeep(siteProfile.website_id, sites) }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</vs-td>
				</vs-tr>
			</template>
			<template slot="append">
				<RouterLink :to="managerSitesLink">
					<vs-button>
						{{ $t('edit') }}
					</vs-button>
				</RouterLink>
			</template>
		</SitesList>
	</div>
</template>

<script>
import SitesList from "@/components/sites-list/SitesList";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "ManagerSites",
	mixins: [databaseManager, notifier],
	props: {
		manager: { type: Object },
	},
	components: {
		SitesList
	},
	data() {
		return {
			sites: [],
			sitesProfiles: [],
		}
	},
	computed: {
		sitesProfilesPairs() {
			return this.getSitesProfilesPairs();
		},
		managerSitesLink() {
			const role = this.$store.state.auth.role;
			if(role === "manager") {
				return "/profile/sites"
			}

			return `/manager/${this.manager.id}/edit-sites`
		}
	},
	methods: {
		getSitesProfilesPairs() {
			const pairs = [];
			const columnsCount = 2;

			for(let i = 0; i < this.sitesProfiles.length; ) {
				const pair = [];

				for(let y = 0; y < columnsCount; y++) {
					if(i < this.sitesProfiles.length) {
						pair.push(this.sitesProfiles[i++]);
					}
				}

				pairs.push(pair);
			}

			return pairs;
		},
		fillMissingProfiles() {
			for(let site of this.sites) {
				const res = this.sitesProfiles.find(item => item.website_id === site.id);

				if(!res) {
					this.sitesProfiles.push({
						username: "---",
						photo: "",
						website_id: site.id
					});
				}
			}
		},
		async updateProfiles() {
			this.sites = await this.dbGetWebSites();

			try {
				const role = this.$store.state.auth.role;
				if(role === "admin") {
					this.sitesProfiles = await this.dbGetManagerProfilesByAdmin(this.manager.id);
				} else if(role === "manager") {
					this.sitesProfiles = await this.dbGetManagerProfiles();
				}

			} catch(e) {
				this.notifyError(e.message);
			}

			this.fillMissingProfiles();
		}
	},
	async mounted() {
		await this.updateProfiles();
	}
};
</script>

<style lang="scss">
.admin-manager-sites-info {
	.vs-table--tbody-table {
		min-width: auto !important;
	}

	.manager-card-container {
		@media screen and (max-width: 570px) {
			width: 100% !important;
		}
	}

	.vx-row > .manager-card-container {
		@media screen and (max-width: 570px) {
			margin-bottom: 20px;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.manager-card {
		display: flex;

		&__photo {
			flex-shrink: 0;
			width: 160px;
			height: 160px;
			border-radius: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		&__info {
			margin-left: 15px;
		}

		&__name {
			font-size: 20px;
			font-weight: 600;
			word-wrap: anywhere;
		}

		@media screen and (max-width: 992px) {
			flex-direction: column;
			align-items: center;

			&__info {
				margin-top: 5px;
				margin-left: 0;
			}

			&__photo {
				width: 210px;
				height: 210px;
			}

			&__name,
			&__site {
				text-align: center;
			}
		}

		@media screen and (max-width: 670px) {
			&__photo {
				width: 160px;
				height: 160px;
			}
		}

		@media screen and (max-width: 570px) {
			&__photo {
				width: 210px;
				height: 210px;
			}
		}

		@media screen and (max-width: 370px) {
			&__photo {
				width: 160px;
				height: 160px;
			}
		}
	}
}
</style>
